'use strict';

const _ = require('lodash');
const {PARSER_ERRORS, UPLOAD_MAX_SIZE, UPLOAD_MAX_SIZE_HUMAN} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
    });

    if (config.required && (_.isNil(input) || input === '')) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    if (!_.isNil(input)) {
        if (!_.isString(input)) {
            throw new ParserError(PARSER_ERRORS.NOT_STRING);
        }
        if (input.length > UPLOAD_MAX_SIZE) {
            throw new ParserError(PARSER_ERRORS.UPLOAD_SIZE, [{max: UPLOAD_MAX_SIZE_HUMAN}]);
        }
        if (!input.startsWith('data:')) {
            throw new ParserError(PARSER_ERRORS.UPLOAD_TYPE_IMAGE);
        }
        const [mime] = input.slice('data:'.length).split(';', 2);
        if (!mime.startsWith('image/')) {
            throw new ParserError(PARSER_ERRORS.UPLOAD_TYPE_IMAGE);
        }
    }

    return input;
};
